import svg from './row-svg/geoportail-v1.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function GeoportailV1Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default GeoportailV1Icon;
